import { MAX_ROOMS_CUTOFF } from 'config';

export const shouldShowAvailableRoomsMessage = (allocationsAvailable) => {
  return allocationsAvailable > 0 && allocationsAvailable <= MAX_ROOMS_CUTOFF;
};
